
<template>
  <blockquote class="com-blockquote">
    <component 
      v-for="child, index in dataInfo.children" 
      :key="index"
      :is="child.cpt" 
      :data-info="child.data"
      :article-info="articleInfo"
    ></component>
  </blockquote>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin'
export default {
  mixins: [CptMixin]
}
</script>

<style lang="less">
.com-blockquote {
  margin: 10px 0 15px;
  padding-left: 15px;
  border-left: 4px solid #e1e6eb;
  * {
    font-size: 14px;
    color: #8c96a0 ;
    line-height: 20px;
  }
  .com-text {
    margin-top: 0px;
    & + .com-text {
      margin-top: 6px;
    }
  }
}
</style>